import { doubleToString } from '../Utils';
import TableCell from '@mui/material/TableCell';

export const PnlTableCell = ({children, align}) => {
    const style = {color: children < 0 ? 'red' : 'blue'}
  return (<TableCell align={align} component="th" style={style} scope="row">{doubleToString(children,2)}</TableCell>)
  }